;(function( $ ) {
	/**
	 * Enables or disables email notifications
	 */
	function update_notifications_status() {
		var $send = $( '#shipper-email-notifications' ),
			action_pfx = 'shipper_notifications_'
		;
		if ( ! $send.length) { return false; }

		$.post(ajaxurl, {
			action: action_pfx + ($send.is( ':checked' ) ? 'enable' : 'disable'),
			_wpnonce: $send.val()
		}).done(function() {
			window.location.reload();
		});
	}

	/**
	 * Updates the shipper email options change button
	 */
	function update_options_change() {
		var $send = $( '.shipper-notification-options :checkbox' ),
			action_pfx = 'shipper_notifications_fail_only_'
		;
		if ( ! $send.length) { return false; }

		$.post(ajaxurl, {
			action: action_pfx + ($send.is( ':checked' ) ? 'enable' : 'disable'),
			_wpnonce: $send.val()
		}).done(function ( rsp ) {
			var status = ! ! (rsp || {}).success,
				msg = (rsp || {}).data || ''
			;

			if ( ! status) {
				$send.attr( 'checked', false );
				return false;
			}
		}).fail(function() {
				$send.attr( 'checked', false );
		});
	}

	/**
	 * Sends out an email addition request
	 */
	function add_email(e) {
		if (e && e.preventDefault) { e.preventDefault(); }
		if (e && e.stopPropagation) { e.stopPropagation(); }

		var $me = $( '#shipper-add-recipient' ),
			email = $me.find( ':input[type="email"]' ).val(),
			name = $me.find( ':input[type="text"]' ).val();
		$.post(ajaxurl, {
			action: 'shipper_notifications_add',
			name: name,
			email: email,
			_wpnonce: $me.find( 'button[data-add]' ).attr( 'data-add' )
		}).done(function ( rsp ) {
			var status   = ! ! (rsp || {}).success,
				rsp_data = (rsp || {}).data || ''
				data     = rsp_data.data || rsp_data; // sometimes data can be nested
				message  = rsp_data.message || rsp_data; // sometimes message can be nested
			;

			if ( ! status) {
				show_error( message );
				return false;
			}

			show_success( message );

			$( '.shipper-notifications-wrapper' ).html(
				$( data ).find( '.shipper-notifications-wrapper' ).html()
			);
			$( '.shipper-notifications-status-notice' ).hide();
			hide_add();
		});

		return false;
	}

	/**
	 * Sends out an email removal request
	 */
	function rmv_email(e) {
		if (e && e.preventDefault) { e.preventDefault(); }
		if (e && e.stopPropagation) { e.stopPropagation(); }

		var $me = $( this ).closest( '.shipper-notification-item' ),
			email = $me.find( '.shipper-email[data-email]' ).attr( 'data-email' );
		$.post(ajaxurl, {
			action: 'shipper_notifications_rmv',
			email: email,
			_wpnonce: $me.find( 'a[data-rmv]' ).attr( 'data-rmv' )
		}).done(function( rsp ) {
			var status   = ! ! (rsp || {}).success,
				rsp_data = (rsp || {}).data || ''
				data     = rsp_data.data || rsp_data; // sometimes data can be nested
				message  = rsp_data.message || rsp_data; // sometimes message can be nested
			;

			if ( ! status) {
				show_error( message );
				return false;
			}

			show_success( message );

			$( '.shipper-notifications-wrapper' ).html(
				$( data ).find( '.shipper-notifications-wrapper' ).html()
			);
			$( '.shipper-notifications-status-notice' ).hide();
		});

		return false;
	}

	function show_error( message ) {
		show_notice( message, 'error' );
	}

	function show_notice( message, type ) {
		message = '<p>' + message + '</p>';
		var options = {
			type: type
		}

		SUI.openNotice( 'shipper-recipient-add-notice', message, options );
	}

	function show_success( message ) {
		show_notice( message, 'success' );
	}

	function reveal_add(e) {
		if (e && e.preventDefault) { e.preventDefault(); }
		if (e && e.stopPropagation) { e.stopPropagation(); }

		var	modalId          = 'shipper-add-recipient',
			focusAfterClosed = this,
			focusWhenOpen    = undefined,
			hasOverlayMask   = false;

		SUI.openModal( modalId, focusAfterClosed, focusWhenOpen, hasOverlayMask );
	}

	function hide_add(e) {
		if (e && e.preventDefault) { e.preventDefault(); }
		if (e && e.stopPropagation) { e.stopPropagation(); }

		var $me = $('#shipper-add-recipient'),
			$email = $me.find(':input[type="email"]'),
			$name = $me.find(':input[type="text"]');

		$email.val('');
		$name.val('');

		SUI.closeModal();
	}

	function enter_to_add_email( e ) {
		var key = e.which;
		if ( 13 === key ) {
			add_email();
		}
	}

	function init() {
		if ($( '.shipper-page-settings-notifications' ).length) {
			$( '#shipper-email-notifications' ).on( 'change', update_notifications_status );
			$( document ).on( 'change', '.shipper-notification-options :checkbox', update_options_change );
			$( document ).on( 'click', '.shipper-notification-item a.shipper-rmv', rmv_email );

			$( document ).on( 'click', 'button.shipper-reveal-add', reveal_add );
			$( document ).on( 'click', '#shipper-add-recipient button.shipper-cancel', hide_add );
			$( document ).on( 'click', '#shipper-add-recipient button.shipper-add', add_email );
			$( document ).on( 'keydown', '#shipper-add-recipient input', enter_to_add_email );

			$( document ).on('click', '.shipper-notifications-save', function() {
				window.location.reload();
			});
		}
	}

	$( init );
})( jQuery );
